import { Rating } from "primereact/rating";
import React from "react";
import { formatDate } from "../../../../utilities/formatDate";
import { Button } from "primereact/button";

const Comment = ({ comments, dateorder, rate, username }) => {
  return (
    <div>
      <div className="flex align-items-center justify-content-between">
        {/*  <div>{username}</div> */}{" "}
        <Rating value={Math.ceil(rate)} readOnly stars={5} cancel={false} />{" "}
        <div>{formatDate(dateorder)}</div>
      </div>

      {comments && (
        <div className="my-3 text-sm font-light" style={{ color: "#344563" }}>
          {comments}
        </div>
      )}
      <div className="flex align-items-center gap-3 mt-2">
        <Button
          rounded
          outlined
          label="É útil"
          icon="pi pi-thumbs-up"
          className="text-xs py-1 px-2"
          style={{ color: "#091E42" }}
        />
        <Button
          rounded
          outlined
          label=" "
          icon="pi pi-thumbs-down"
          className="text-xs py-1 px-2"
          style={{ color: "#091E42" }}
        />
      </div>
    </div>
  );
};

export default Comment;
